import BrandPage from './brand.container';

export default BrandPage;